export const INBOX_RESET_STATE = 'INBOX_RESET_STATE';
export const INBOX_CURRENT_ITEM = 'INBOX_CURRENT_ITEM';

export const INBOX_REQUEST_LOADING = 'INBOX_REQUEST_LOADING';
export const INBOX_REQUEST_SUCCESS = 'INBOX_REQUEST_SUCCESS';
export const INBOX_REQUEST_FAILED = 'INBOX_REQUEST_FAILED';

export const INBOX_CURRENT_ACTION = 'INBOX_CURRENT_ACTION';
export const INBOX_RESET_ACTION = 'INBOX_RESET_ACTION';